import { useTranslation } from "react-i18next";

import FriendsWithBenefitsIllustration from "@/assets/friendsWithBenefits/friendsWithBenefits.svg?react";
import { CardContainer } from "@/components/Layout/BaseLayouts/CardContainer";

/**
 * Page header of the Friends with Benefits screens: the illustration tile next
 * to the page title and its subline. Shared by the group overview and the
 * create-group screen, which use the identical header in the design.
 *
 * On mobile the illustration sits above the title, aligned to the right edge,
 * because the title needs the full width there.
 */
export const FriendsWithBenefitsHeader = () => {
  const { t } = useTranslation("portal", {
    keyPrefix: "friendsWithBenefits.groupOverview",
  });

  return (
    <section className="w-full">
      <CardContainer
        dataTestid="fwb-header-card"
        className="flex w-full flex-col rounded-lg p-gutter"
        variant="ivory"
      >
        <div className="flex w-full flex-col gap-gutter tablet:flex-row tablet:items-end">
          <div className="flex size-24 shrink-0 items-center justify-center self-end rounded-lg bg-surface-primary-inverse tablet:self-auto">
            <FriendsWithBenefitsIllustration className="size-14" />
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <h1 className="text-headline-xl font-semibold leading-xs tracking-[-0.02em] text-foreground-primary">
              {t("friendsGroup")}
            </h1>
            <p className="text-body-sm leading-none text-foreground-primary">
              {t("subheading")}
            </p>
          </div>
        </div>
      </CardContainer>
    </section>
  );
};
